// components/SectionHeader.js
import React from 'react';
import { Typography } from '@mui/material';

const TabTitle = ({ title }) => (
  <Typography
    sx={{
      fontSize: {xl: '18px' , lg: '18px' , md: '16px' , sm: '16px' , xs: '16px'},
      fontWeight: '600',
      color: '#1A1F36',
      pb: '20px',
      borderBottom: '1px solid #ccc',
      mb: '20px',
    }}
  >
    {title}
  </Typography>
);

export default TabTitle;
